"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var analytics_1 = require("utils/analytics");
var other_1 = require("utils/selectors/other");
var single_1 = require("utils/selectors/single");
var DesignSystemSidebarItem_1 = __importDefault(require("./DesignSystemSidebarItem"));
var CompanySettings_1 = __importDefault(require("./SettingCategories/CompanySettings"));
var PersonalSettings_1 = __importDefault(require("./SettingCategories/PersonalSettings"));
var SuperAdminSettings_1 = __importDefault(require("./SettingCategories/SuperAdminSettings"));
var SidebarSection_1 = __importDefault(require("./SidebarSection"));
var SettingsSidebar = function (_a) {
    var isLocked = _a.isLocked;
    var history = (0, react_router_1.useHistory)();
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var canAdmin = (0, react_redux_1.useSelector)((0, other_1.makeSelectUserCan)(interfaces_1.ACCESS_LEVEL.Admin));
    var track = (0, analytics_1.usePreparedTracker)('Button Clicked');
    return ((0, jsx_runtime_1.jsxs)(SidebarSection_1.default, { children: [(0, jsx_runtime_1.jsx)(PersonalSettings_1.default, { isLocked: isLocked }), canAdmin && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2 }, { children: (0, jsx_runtime_1.jsx)(CompanySettings_1.default, { isLocked: isLocked }) })), myProfile.isAdmin && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2 }, { children: (0, jsx_runtime_1.jsx)(SuperAdminSettings_1.default, {}) })), (0, jsx_runtime_1.jsx)(DesignSystemSidebarItem_1.default, {})] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () {
                    track({ action: 'Back to Dashboard' });
                    history.push('/');
                }, sx: { my: 2, mr: 1, ml: 3 } }, { children: "Back to Dashboard" }))] }));
};
exports.default = SettingsSidebar;
